export const api = process.env.VUE_APP_URL;
export const api_absolute = process.env.VUE_APP_URL_ABSOLUTE;
export const google_auth_url = process.env.VUE_APP_GOOGLE_AUTH_URL;
export const service = process.env.VUE_APP_SERVICE;
export const origin = process.env.VUE_APP_ORIGIN;
export const reference = process.env.VUE_APP_REFERENCE;
export const landing = process.env.VUE_APP_LANDING;
export const frontend_url = process.env.FRONTEND_URL;
